import React, { useState } from 'react';

import { Alert, Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { generateUUID } from 'utils/Helpers/UUID';
import { PatientStatus, SmartEventCondition } from 'constants/enums';

import { AddSmartEventConditionModal, SmartEventConditionsTable } from '.';

interface IConditionsStepProps {
  conditions: ISmartEventConditionForm[];
  setConditions: any;
  setNoTriggerError: any;
}

const ConditionsStep = ({ conditions, setConditions, setNoTriggerError }: IConditionsStepProps) => {
  const intl = useIntl();
  const [addCondition, setAddCondition] = useState(false);

  const handleAddCondition = (values: ISmartEventConditionForm | null) => {
    if (values) {
      setConditions([...conditions, { id: generateUUID(), ...values }]);
    }
    setAddCondition(false);
    setNoTriggerError(false);
  };

  const nonMeasurementConditionStatus =
    conditions.findIndex(
      (condition) =>
        condition.profileTarget === 'patientStatus' &&
        [
          PatientStatus.REFERRED,
          PatientStatus.DEVICE_ORDERED,
          PatientStatus.DEVICE_SHIPPED
        ].includes(condition.value as PatientStatus) &&
        condition.condition === SmartEventCondition.EQUALS
    ) !== -1;

  const hasMeasurementCondition =
    conditions.findIndex((condition) => condition.conditionType === 'observation_value') !== -1;

  const showStatusMeasurementWarning = nonMeasurementConditionStatus && hasMeasurementCondition;

  return (
    <>
      {showStatusMeasurementWarning && (
        <Alert variant="warning">{intl.formatMessage({ id: 'conditionsWontTriggerKey' })}</Alert>
      )}
      <h5 className="m-0 mt-4">{intl.formatMessage({ id: 'conditionsKey' })}</h5>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <p className="m-0">{intl.formatMessage({ id: 'minimumConditionKey' })}</p>
        <Button
          variant="link"
          className="m-0"
          onClick={() => setAddCondition(true)}
          data-test="smart-event-add-condition"
        >
          + {intl.formatMessage({ id: 'conditionKey' })}
        </Button>
      </div>
      <SmartEventConditionsTable conditions={conditions} setConditions={setConditions} />
      <AddSmartEventConditionModal show={addCondition} close={handleAddCondition} />
    </>
  );
};

export default ConditionsStep;
